/**
 * Termo de Uso do Portal do Fornecedor.
 *
 * **O texto mora no código de propósito.** Ele é o objeto do aceite, e um aceite
 * só vale se der para provar *o que* foi aceito. Aqui o histórico do git guarda
 * cada palavra de cada versão, com data e autor — e o servidor grava, junto do
 * aceite, o **SHA-256 deste texto exato**. Um texto editável por tela exigiria
 * versionar conteúdo no banco para responder a mesma pergunta, com mais peças.
 *
 * **Mudou o texto, sobe a versão.** `PORTAL_TERMS_VERSION` é o que faz todo
 * mundo aceitar de novo: o portal compara a versão gravada no usuário com esta.
 * Corrigir uma vírgula sem subir a versão deixaria metade da base com o hash de
 * um texto que não existe mais.
 *
 * **Um parágrafo por linha, sem quebras manuais** — e não é preferência de
 * estilo. A tela renderiza com `whitespace-pre-wrap`, então toda quebra daqui
 * vira quebra no navegador: a v1.0 saiu quebrada em ~100 colunas para caber
 * bonito no editor, e apareceu picotada no meio das frases para quem lia. Quem
 * decide onde a linha termina é a largura da tela, não a do arquivo. As linhas
 * longas abaixo são o texto, não código — e o diff por parágrafo é o que se quer
 * num documento normativo.
 *
 * Não confundir com o **Termo de Aceite do Manual do Fornecedor** (`RQ 271-00`):
 * aquele é da **empresa**, por edição do Manual, e só o responsável assina.
 * Este é **pessoal** — vale para cada usuário, inclusive os da Weloze.
 */
export const PORTAL_TERMS_VERSION = '1.1';
export const PORTAL_TERMS_TITLE = 'Termo de Uso do Portal do Fornecedor';
/**
 * O texto. Uma cláusula por item, em português claro e na segunda pessoa — quem
 * lê é a pessoa que vai clicar, não o jurídico.
 */
export const PORTAL_TERMS_TEXT = `1. Objeto

O Portal do Fornecedor da Metalúrgica Weloze Ltda ("Portal") é o canal pelo qual a Weloze disponibiliza a avaliação de desempenho dos seus fornecedores, trata não conformidades e recebe documentos do sistema da qualidade. O uso do Portal está sujeito a este Termo e ao Manual do Fornecedor na edição vigente.

2. Seu acesso é pessoal e intransferível

O acesso é concedido a você, nominalmente. A senha é escolhida por você e não é conhecida por ninguém da Weloze. Não compartilhe suas credenciais: tudo o que for feito com o seu usuário é registrado em seu nome e será atribuído a você.

Avise a Weloze imediatamente, pelo e-mail qualidade@weloze.com.br, se você deixar a empresa, se outra pessoa precisar de acesso, ou se suspeitar que alguém usou a sua conta.

3. Confidencialidade

As informações a que você tem acesso no Portal — índices, relatórios, não conformidades, pedidos, notas fiscais e documentos — são confidenciais e destinam-se exclusivamente à relação de fornecimento entre a sua empresa e a Weloze. Não as divulgue a terceiros nem as utilize para outra finalidade.

Você enxerga apenas os dados das empresas para as quais recebeu acesso. Tentar alcançar dados de outro fornecedor é uso indevido do Portal.

4. Informações que você envia

Você é responsável pela veracidade e pela atualidade do que envia — certificados, licenças, respostas de 8D, evidências e demais documentos. Envie apenas arquivos livres de código malicioso e sobre os quais a sua empresa tenha direito.

A Weloze pode recusar, substituir ou remover conteúdo enviado em desacordo com este Termo.

5. Registro de uso

Para fins de auditoria e de segurança, o Portal registra os acessos, os downloads de documentos, os e-mails enviados e as alterações realizadas, com identificação do usuário, data, hora e endereço IP. Esses registros são prova do cumprimento dos requisitos do sistema da qualidade e podem ser apresentados em auditorias de clientes e de organismos certificadores.

6. Proteção de dados pessoais

A Weloze trata os dados pessoais necessários para identificar quem acessa o Portal — nome, e-mail corporativo, cargo e registros de acesso — com base no legítimo interesse e na execução da relação contratual, nos termos da Lei nº 13.709/2018 (LGPD). Os dados não são cedidos a terceiros para finalidade diversa.

Para exercer seus direitos de titular, escreva para qualidade@weloze.com.br. A Política de Privacidade da Weloze está disponível no site da empresa.

7. Disponibilidade

A Weloze empenha-se em manter o Portal disponível, mas não garante funcionamento ininterrupto. Em caso de indisponibilidade, as informações podem ser solicitadas pelo e-mail qualidade@weloze.com.br, e os prazos do Manual do Fornecedor permanecem válidos.

8. Encerramento do acesso

A Weloze pode suspender ou encerrar o seu acesso a qualquer momento, em especial quando você deixar de representar a empresa fornecedora, quando a empresa deixar de ser monitorada, ou em caso de descumprimento deste Termo. O encerramento do acesso não apaga os registros já produzidos.

9. Alterações deste Termo

Este Termo pode ser revisado. Quando isso ocorrer, uma nova versão será apresentada no seu próximo acesso, e o uso do Portal dependerá do aceite dela.

10. Foro

Fica eleito o foro da comarca de Caxias do Sul/RS para dirimir questões oriundas deste Termo.`;
//# sourceMappingURL=terms.js.map